/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";

// reactstrap components
import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";
import {connect} from "react-redux";
import {showModalCreator} from "../../reducers/modalReducer";
import ImprintModal from "./ImprintModal";
import AboutModal from "./AboutModal";

class Login extends React.Component {

  constructor(props) {
    super(props);

    this.imprintModalName = "ImprintModal";
    this.aboutModalName =  "aboutModalName";
  }

  render() {
    const {showImprintModal, showAboutModal} = this.props;

    return (
      <>
        <footer className="py-5">
          <Container>
            <Row className="align-items-center justify-content-xl-between">
              <Col xl="6">
                <div className="copyright text-center text-xl-left text-muted">
                  © 2020{" "}
                  <a
                    className="font-weight-bold ml-1"
                    href="https://www.k3-services.at"
                    target="_blank"
                  >
                    K3 Services e.U.
                  </a>
                </div>
              </Col>
              <Col xl="6">
                <Nav className="nav-footer justify-content-center justify-content-xl-end">
                  <NavItem>
                    <NavLink onClick={(e) => {
                      e.preventDefault();
                      showImprintModal(this.imprintModalName);
                    }}
                             href="javascript:void(0)"
                             rel="noopener noreferrer">Impressum</NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                        onClick={(e) => {
                          e.preventDefault();
                          showAboutModal(this.aboutModalName);
                        }}
                        href="javascript:void(0)"
                        rel="noopener noreferrer"
                    >
                      Über diese Applikation
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md?ref=adr-auth-footer"
                      target="_blank"
                    >
                      MIT License
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
          </Container>
          <ImprintModal modalName={this.imprintModalName}/>
          <AboutModal modalName={this.aboutModalName}/>
        </footer>
      </>
    );
  }
}

export default connect((state, ownProps) => ({

}), (dispatch) => ({
  showImprintModal: (imprintModalName) => dispatch(showModalCreator(imprintModalName)),
  showAboutModal: (aboutModalName) => dispatch(showModalCreator(aboutModalName))
}))(Login);
